import { format } from 'date-fns';
import React from 'react';
import { gql } from '@urql/core';
import { PlayerSendsMessageFragment } from '../../../../generated/spin-graphql';

type Props = {
    message: PlayerSendsMessageFragment;
};

gql`
    fragment PlayerSendsMessage on espin_message {
        contents
        created_at
        player_user {
            player_profile {
                first_name
                last_name
            }
            deleted_at
        }
        parent_user_id
    }
`;

export const PlayerSendsMessage: React.FC<Props> = ({ message }) => {
    const nameLabel = !!message.player_user?.deleted_at
        ? 'Deleted User'
        : `${message.player_user?.player_profile?.first_name} ${message.player_user?.player_profile?.last_name}`;
    const author = `${nameLabel}${!!message.parent_user_id ? "'s Parent" : ''}`;
    return (
        <div className="message-container">
            <div className="bubble">{message.contents}</div>
            <div className="message-stamp">
                <span className="author">{author}</span>
                {author && <>{'-'}</>}
                <span className="timestamp">{format(new Date(message.created_at), 'MMM d, y, h:mm a')}</span>
            </div>
        </div>
    );
};
